import axios from 'axios';
import { Modal } from 'iview';
import { getToken, setToken } from '@/libs/util';
import { getStorage, STORAGE_KEYS } from '@/utils/localStorage';

class HttpRequest {
    constructor(baseUrl, fileServerUrl) {
        this.baseUrl = baseUrl;
        this.fileServerUrl = fileServerUrl;
        this.queue = {};
    }
    getBaseUrl() {
        return this.baseUrl;
    }
    getFileServerUrl() {
        return this.fileServerUrl;
    }
    getInsideConfig() {
        const config = {
            baseURL: this.baseUrl,
            fileServerURL: this.fileServerUrl,
            headers: {
                //
            }
        };
        return config;
    }
    destroy(url) {
        delete this.queue[url];
        if (!Object.keys(this.queue).length) {
            // Spin.hide()
        }
    }
    interceptors(instance, url) {
        // 请求拦截
        instance.interceptors.request.use(config => {
            let token = getToken();
            if (config.data instanceof FormData) {
                config.data.append('token', token);
            }
            else {
                config.data = {
                    ...config.data,
                    token: token || ''
                };
            }

            // 添加用户UUID和用户名
            const userId1 = getStorage(STORAGE_KEYS.USER_UUID) || '';
            const userCode1 = getStorage(STORAGE_KEYS.USER_NAME) || '';
            if (config.data instanceof FormData) {
                config.data.append('userId1', userId1);
                config.data.append('userCode1', userCode1);
            }
            else {
                config.data = {
                    ...config.data,
                    userId1,
                    userCode1
                };
            }

            // 添加全局的loading...
            if (!Object.keys(this.queue).length) {
                // Spin.show() // 不建议开启，因为界面不友好
            }
            this.queue[url] = true;
            return config;
        }, error => {
            return Promise.reject(error);
        });
        // 响应拦截
        instance.interceptors.response.use(res => {
            let response = res.data;

            // 登录状态检查
            const uuid = getStorage(STORAGE_KEYS.USER_UUID) || '';
            const code = getStorage(STORAGE_KEYS.USER_NAME) || '';
            // 如果 uuid 和 code 都为空，跳转到登录页面
            if (!uuid && !code) {
                // 检查当前路径是否为登录页面
                if (!(url.toLowerCase().includes('login')||url.toLowerCase().includes('token'))) {
                    setToken('');
                    location.reload();
                    // 取消请求
                    return Promise.reject(new Error('未登录，跳转到登录页面'));
                }
            }

            if (response.code !== 0 && response.code !== 4) {
                if (response.code === 100000) {
                    Modal.error({
                        title: '操作失败',
                        // content:'发生未知错误，请联系系统管理员。',
                        content: response.message,
                        closable: false
                        // okText: '查看更多',
                        // onOk: function () {
                        //     setTimeout(function () {
                        //         this.$Modal.info({
                        //             title: '更多错误描述',
                        //             content: response.data,
                        //             width: '95%',
                        //             scrollable: true
                        //         });
                        //     }.bind(this), 301);
                        // }
                    });
                }
                else {
                    setTimeout(function () {
                        Modal.error({
                            title: '操作失败',
                            content: response.message,
                            closable: false,
                            onOk: function () {
                                switch (response.code) {
                                    case 100001:
                                        setToken('');
                                        location.reload();
                                        break;
                                    default:
                                        break;
                                };
                            }
                        });
                    }, 301);
                }
            }

            this.destroy(url);
            return res.data;
        }, error => {
            // 如果是未登录跳转错误，不显示错误模态框
            if (!error.message || error.message.indexOf('未登录') === -1) {
                Modal.error({
                    title: '出错了',
                    content: '全局接口访问失败（请检查接口情况）'
                });
            }

            this.destroy(url);
            return Promise.reject(error);
        });
    }
    request(options) {
        const instance = axios.create();
        options = Object.assign(this.getInsideConfig(), options);
        this.interceptors(instance, options.url);
        return instance(options);
    }
}
export default HttpRequest;
